/** WhatsApp’s current message-pin choices (separate from inbox chat pins). */
export const MAX_PINNED_MESSAGES = 4;
export const DEFAULT_PIN_DURATION_SEC = 7 * 24 * 60 * 60;
export const PIN_DURATION_CHOICES = [
  { label: "24 hours", seconds: 24 * 60 * 60 },
  { label: "7 days", seconds: DEFAULT_PIN_DURATION_SEC },
  { label: "30 days", seconds: 30 * 24 * 60 * 60 },
] as const;

export function pinExpiresAt(
  pinnedAt: Date,
  durationSec = DEFAULT_PIN_DURATION_SEC,
) {
  return new Date(pinnedAt.getTime() + durationSec * 1000);
}
export function isActivePin(
  pin: { pinnedAt?: Date | null; pinnedExpiresAt?: Date | null },
  now = Date.now(),
) {
  return (
    !!pin.pinnedAt &&
    (pin.pinnedExpiresAt ?? pinExpiresAt(pin.pinnedAt)).getTime() > now
  );
}
